import { BaseApi } from '@/main/baseApi';

const DMS_MODULE = 'CustomerFeedback';
const NAME = 'CustomerFeedback';


class CustomerFeedback extends BaseApi {
	async getDetailsForFeedback(GuId: string | null, tenant: any) {
		return this.fetch(`/${DMS_MODULE}/GetDetailsForFeedback?FeedbackGuId=${GuId}&tenant=${tenant}`);
	}

	async submitFeedback(dto: any, tenant: any) {
		return this.post(`/${DMS_MODULE}/SaveCustomerFeedback?tenant=${tenant}`, dto);
	}

	async verifyAccount(SenderEmailId: any) {
		return this.fetch(`EmailVerification/VerifyAccount?emailId='${SenderEmailId}`);
	}

	async setLoggedInUserLanguageId(languageId: number) {
		return this.fetch(`Resource/SetLoggedInUserLanguageId?languageId=${languageId}`);
	}

	async GetWorkShops() {
		return this.fetch(`/DropdownList/GetProvozovna`);
	}
	async GetDealerDetails() {
		return this.fetch(`Administrace/Organizace/GetDealerDetails`);
	}
	async DealerWorkShopDetails(params: any) {
		return this.fetch(`Administrace/Provozovna/DealerWorkShopDetails`,params);
	}
	async CheckVP(userId: number, page: string, pageMode: string) {
		return this.fetch(`Administrace/Provozovna/CheckVP`, { userId, page, pageMode });
	}
}
export const apiProvider = new CustomerFeedback(DMS_MODULE, NAME);
